import config from '../data/config.json';

// Accepted during the transition only; do not offer these on new entries.
const legacyValues = {
  SEC_OWNER: ['BT', 'CB', 'CK', 'CM', 'CT', 'DL', 'EA', 'EC', 'KL', 'LA', 'ML', 'MP', 'PD', 'RA', 'SH', 'VR', 'WJ', 'Liam', 'TR', 'DE'],
  SEC_OWNER_TEAM: ['AA', 'CRE', 'Credit', 'Mortgages', 'OCIO', 'PSP', 'SP'],
};

const choicesByField = {
  SEC_OWNER: config.securityOwners,
  SEC_OWNER_TEAM: config.securityOwnerTeams,
};

export const getOwnerFieldOptions = (field, currentValue) => {
  const choices = choicesByField[field];
  if (!choices) throw new Error(`Unknown owner field: ${field}`);
  // Prepend the existing code so No Analyst required and blank stay at the end.
  return legacyValues[field].includes(currentValue) && !choices.includes(currentValue)
    ? [currentValue, ...choices]
    : [...choices];
};

export const getAcceptedOwnerValues = (field) => {
  if (!choicesByField[field]) throw new Error(`Unknown owner field: ${field}`);
  return [...new Set([...choicesByField[field], ...legacyValues[field]])];
};
